// extracted by mini-css-extract-plugin
export default {"container":"s04_container__H70i5","slider":"s04_slider__E7ql5","slide":"s04_slide__EuHQ8"};